import { SVGProps } from 'react'

export const EditIcon2 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="19"
    height="19"
    viewBox="0 0 19 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.9997 8.33326L10.6664 4.99993M1.08301 17.9166L3.90331 17.6032C4.24789 17.5649 4.42018 17.5458 4.58121 17.4937C4.72408 17.4474 4.86005 17.3821 4.98541 17.2994C5.12672 17.2062 5.2493 17.0836 5.49445 16.8385L16.4997 5.83326C17.4202 4.91279 17.4202 3.4204 16.4997 2.49993C15.5792 1.57945 14.0868 1.57945 13.1664 2.49992L2.16112 13.5052C1.91596 13.7503 1.79339 13.8729 1.70021 14.0142C1.61753 14.1396 1.55219 14.2755 1.50594 14.4184C1.4538 14.5794 1.43466 14.7517 1.39637 15.0963L1.08301 17.9166Z"
      stroke="#1CAEFF"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
